// extracted by mini-css-extract-plugin
export default {"body":"_2yzvbm49","visible":"_38U3jUEx","hidden":"_30v3JRC8","fullBleed":"_1_zdslWs"};